import './fdx-login-form.styles.scss';
import FdxLoginFormController from './fdx-login-form.controller.js';

angular.module('feedAuthApp').component('fdxLoginForm', {
    template: require('./fdx-login-form.template.html'),
    controller: FdxLoginFormController
});